import React, { useState } from 'react';
import axios from "axios";
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';
import {
  EmailOutlined,
  LockOutlined,
  Security,
  Visibility,
  VisibilityOff
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import loginVideo from '../assets/try-3.mp4';



const API_BASE_URL = "https://api.gwayinsure.in";
const API = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20000 // 20 seconds timeout
});

const MotionPaper = motion.create(Paper);
const MotionBox = motion.create(Box);

const LoginPage = ({ onLoginSuccess, setUserName }) => {
  const [formData, setFormData] = useState({
    userName: '',
    password: ''
  });
  const [fieldErrors, setFieldErrors] = useState({
    userName: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setFieldErrors({ ...fieldErrors, [e.target.name]: '' });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Manual validation to replace default browser tooltips
    let valid = true;
    let newFieldErrors = { userName: '', password: '' };

    if (!formData.userName.trim()) {
      newFieldErrors.userName = "Please fill out this field.";
      valid = false;
    }
    if (!formData.password.trim()) {
      newFieldErrors.password = "Please fill out this field.";
      valid = false;
    }

    if (!valid) {
      setFieldErrors(newFieldErrors);
      return;
    }

    setIsLoading(true);
    setError("");

    await new Promise(r => setTimeout(r, 800));

    var loginJson = {
      "userName": formData.userName,
      "passWord": formData.password
    };

    try {
      const responce = await API.post("/api/auth/login", loginJson);
      if (responce) {
        console.log("Login Success Response:", responce);
        const displayName = responce.data.name || responce.data.userName;
        setUserName(displayName);
        sessionStorage.setItem("userName", displayName);
        sessionStorage.setItem("loginId", responce.data.userName);
        sessionStorage.setItem("token", responce.data.token.split("").reverse().join(""));
        sessionStorage.setItem("userRole", responce.data.userRole);
        sessionStorage.setItem("userId", responce.data.userId);
        sessionStorage.setItem("profilePic", responce.data.profilePic || "");
        sessionStorage.setItem("sessionActiveTime", JSON.stringify(new Date().getTime() + 8 * 60 * 60 * 1000));
        onLoginSuccess(responce.data.userRole);
      }
    } catch (err) {
      console.error("Login attempt failed:", err.message);
      setIsLoading(false);

      if (err.code === 'ECONNABORTED' || err.message.toLowerCase().includes('timeout')) {
        setError("Login request timed out. Please check your network and try again.");
      } else if (err.response) {
        setError("Invalid UserName or password. Please try again.");
      } else {
        setError("Network error. Please ensure the server is reachable.");
      }
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        overflow: 'hidden',
        background: '#000',
        position: 'relative'
      }}
    >
      {/* VIDEO BACKGROUND CONTAINER */}
      <Box
        sx={{
          flex: { md: 2 },
          position: { xs: 'absolute', md: 'relative' },
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          zIndex: { xs: 0, md: 1 }
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
            opacity: 0.95
          }}
        >
          <source src={loginVideo} type="video/mp4" />
        </video>

        {/* OVERLAY GRADIENT */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: {
              xs: 'linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.8) 100%)',
              md: 'linear-gradient(to right, rgba(0,0,0,0.1) 0%, rgba(5,5,5,0.4) 70%, rgba(5, 5, 5, 1) 100%)'
            },
            zIndex: 1
          }}
        />

        {/* BRANDING (HIDDEN ON MOBILE CONTENT FLOW, MOVED TO FORM OVERLAY) */}
        <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            height: '100%',
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'column',
            justifyContent: 'center',
            p: { md: 8, lg: 12 },
          }}
        >
          <motion.div
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            {/* <Box sx={{ display: 'flex', alignItems: 'center', mb: 0 }}>
              <Security sx={{ fontSize: { md: 60, lg: 80 }, color: '#FDB813', mr: 2.5 }} />
              <Typography
                variant="h1"
                sx={{
                  color: 'white',
                  fontWeight: 900,
                  fontFamily: "'Outfit', sans-serif",
                  fontSize: { md: '4rem', lg: '5rem' },
                  lineHeight: 1,
                  textShadow: '0 10px 30px rgba(0,0,0,0.5)'
                }}
              >
                GateWay
              </Typography>
            </Box>
            <Typography
              variant="h4"
              sx={{
                color: '#FDB813',
                fontWeight: 700,
                letterSpacing: 10,
                fontFamily: "'Outfit', sans-serif",
                mb: 5,
                textShadow: '0 5px 15px rgba(0,0,0,0.5)'
              }}
            >
              INSURANCE
            </Typography>
            <Box sx={{ width: 60, height: 4, bgcolor: '#FDB813', mb: 3, borderRadius: 2 }} />
            <Typography
              variant="h6"
              sx={{
                color: 'rgba(255, 255, 255, 1)',
                maxWidth: '450px',
                fontWeight: 400,
                lineHeight: 1.7,
                fontSize: '1rem',
                letterSpacing: 0.5
              }}
            >
              Institutional-grade security and seamless insurance management through our state-of-the-art gateway.
            </Typography> */}
          </motion.div>
        </Box>
      </Box>

      {/* RIGHT SIDE – LOGIN FORM */}
      <Box
        sx={{
          flex: { md: 1.2 },
          width: { xs: '100%', md: 'auto' },
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: { xs: 'rgba(0,0,0,0.6)', md: '#000000ff' },
          backdropFilter: { xs: 'blur(10px)', md: 'none' },
          position: 'relative',
          px: { xs: 4, md: 10, lg: 12 },
          zIndex: 2
        }}
      >
        {/* MOBILE LOGO (ONLY ON XS) */}
        <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', mb: 4 }}>
          <Security sx={{ fontSize: 40, color: '#FDB813', mr: 1.5 }} />
          <Typography
            variant="h4"
            sx={{ color: 'white', fontWeight: 900, fontFamily: "'Outfit', sans-serif" }}
          >
            GateWay
          </Typography>
        </Box>

        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          sx={{ 
            width: '100%', 
            maxWidth: '440px', 
            position: 'relative', 
            zIndex: 1,
            textAlign: 'center' 
          }}
        >
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 900,
                fontFamily: "'Outfit', sans-serif",
                mb: 1,
                letterSpacing: -1.2,
                background: 'linear-gradient(135deg, #FFFFFF 0%, #FDB813 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                display: 'inline-block',
                fontSize: { xs: '2.2rem', md: '2.4rem', lg: '2.8rem' },
                textAlign: 'center'
              }}
            >
              Welcome Back
            </Typography>
            <Typography sx={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)', letterSpacing: 1, textAlign: 'center' }}>
              Security initialized. Please enter your credentials.
            </Typography>
          </Box>

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              name="userName"
              label="Username"
              value={formData.userName}
              onChange={handleChange}
              margin="dense"
              variant="outlined"
              error={!!fieldErrors.userName}
              helperText={fieldErrors.userName}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailOutlined sx={{ color: '#FDB813', mr: 1, fontSize: '1.1rem' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                mb: fieldErrors.userName ? 1 : 2,
                '& .MuiOutlinedInput-root': {
                  height: '52px',
                  borderRadius: '12px',
                  color: 'white',
                  fontSize: '0.95rem',
                  backgroundColor: 'rgba(255, 255, 255, 0.02)',
                  backdropFilter: 'blur(5px)',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  '& fieldset': { 
                    borderColor: 'rgba(255, 255, 255, 0.08)',
                    transition: 'border-color 0.3s ease'
                  },
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.04)',
                    '& fieldset': { 
                      borderColor: fieldErrors.userName ? '#ff4d4d' : 'rgba(253, 184, 19, 0.3)' 
                    },
                  },
                  '&.Mui-focused': {
                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                    boxShadow: fieldErrors.userName ? '0 0 20px rgba(255, 77, 77, 0.1)' : '0 0 20px rgba(253, 184, 19, 0.1)',
                  },
                  '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active': {
                    transition: 'background-color 5000s ease-in-out 0s',
                    WebkitBoxShadow: '0 0 0 1000px #000 inset !important',
                    WebkitTextFillColor: 'white !important',
                    caretColor: 'white !important'
                  },
                },
                '& .MuiInputLabel-root': { 
                  color: 'rgba(255, 255, 255, 0.3)',
                  fontSize: '0.9rem',
                  '&.Mui-focused': { color: fieldErrors.userName ? '#ff4d4d' : '#FDB813' },
                },
                '& .MuiFormHelperText-root': {
                  color: '#ff4d4d',
                  fontWeight: 500,
                  fontSize: '0.7rem',
                  ml: 1.5,
                  mt: 0.2
                }
              }}
            />
            <TextField
              fullWidth
              name="password"
              type={showPassword ? "text" : "password"}
              label="Password"
              value={formData.password}
              onChange={handleChange}
              margin="dense"
              variant="outlined"
              error={!!fieldErrors.password}
              helperText={fieldErrors.password}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOutlined sx={{ color: '#FDB813', mr: 1, fontSize: '1.1rem' }} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      onMouseDown={(e) => e.preventDefault()}
                      edge="end"
                      size="small"
                      sx={{ color: 'rgba(255, 255, 255, 0.3)', mr: 0.2 }}
                    >
                      {showPassword ? <VisibilityOff sx={{ fontSize: '1.1rem' }} /> : <Visibility sx={{ fontSize: '1.1rem' }} />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                mb: fieldErrors.password ? 2 : 3,
                '& .MuiOutlinedInput-root': {
                  height: '52px',
                  borderRadius: '12px',
                  color: 'white',
                  fontSize: '0.95rem',
                  backgroundColor: 'rgba(255, 255, 255, 0.02)',
                  backdropFilter: 'blur(5px)',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  '& fieldset': { 
                    borderColor: 'rgba(255, 255, 255, 0.08)',
                    transition: 'border-color 0.3s ease'
                  },
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.04)',
                    '& fieldset': { 
                      borderColor: fieldErrors.password ? '#ff4d4d' : 'rgba(253, 184, 19, 0.3)' 
                    },
                  },
                  '&.Mui-focused': {
                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                    boxShadow: fieldErrors.password ? '0 0 20px rgba(255, 77, 77, 0.1)' : '0 0 20px rgba(253, 184, 19, 0.1)',
                  },
                  '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active': {
                    transition: 'background-color 5000s ease-in-out 0s',
                    WebkitBoxShadow: '0 0 0 1000px #000 inset !important',
                    WebkitTextFillColor: 'white !important',
                    caretColor: 'white !important'
                  },
                },
                '& .MuiInputLabel-root': { 
                  color: 'rgba(255, 255, 255, 0.3)',
                  fontSize: '0.9rem',
                  '&.Mui-focused': { color: fieldErrors.password ? '#ff4d4d' : '#FDB813' },
                },
                '& .MuiFormHelperText-root': {
                  color: '#ff4d4d',
                  fontWeight: 500,
                  fontSize: '0.7rem',
                  ml: 1.5,
                  mt: 0.2
                }
              }}
            />

            {error && (
              <Box
                sx={{
                  width: '100%',
                  mb: 2,
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid rgba(255, 59, 59, 0.35)',
                  background: 'linear-gradient(135deg, rgba(180, 0, 0, 0.55) 0%, rgba(120, 0, 0, 0.55) 100%)',
                  backdropFilter: 'blur(12px)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  px: 2,
                  py: 1.4,
                  boxShadow: '0 4px 24px rgba(200, 0, 0, 0.25), inset 0 1px 0 rgba(255,255,255,0.06)',
                }}
              >
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    bgcolor: '#ff4d4d',
                    flexShrink: 0,
                    boxShadow: '0 0 8px #ff4d4d',
                    animation: 'errorPulse 1.5s ease-in-out infinite',
                  }}
                />
                <Typography
                  sx={{
                    color: '#ffcdd2',
                    fontSize: '0.82rem',
                    fontWeight: 600,
                    fontFamily: "'Outfit', sans-serif",
                    letterSpacing: 0.3,
                    lineHeight: 1.4,
                  }}
                >
                  {error}
                </Typography>
                <style>{`
                  @keyframes errorPulse {
                    0%, 100% { opacity: 1; transform: scale(1); }
                    50% { opacity: 0.5; transform: scale(1.4); }
                  }
                `}</style>
              </Box>
            )}

            <Button
              fullWidth
              type="submit"
              disabled={isLoading}
              sx={{
                py: 1.5,
                borderRadius: '12px',
                fontWeight: 900,
                fontSize: '1rem',
                color: '#000',
                bgcolor: '#FDB813',
                letterSpacing: 1.5,
                position: 'relative',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                '&:hover': {
                  bgcolor: '#ffc12e',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 10px 25px rgba(253, 184, 19, 0.2)',
                  '& .shine': {
                    left: '100%',
                    transition: 'all 0.5s ease'
                  }
                },
                '&:active': { transform: 'translateY(0)' },
              }}
            >
              {isLoading ? 'VERIFYING...' : 'ACCESS PORTAL'}
              <Box
                className="shine"
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: '-100%',
                  width: '50%',
                  height: '100%',
                  background: 'linear-gradient(to right, transparent, rgba(255,255,255,0.4), transparent)',
                  transform: 'skewX(-25deg)',
                }}
              />
            </Button>
          </form>

          <Typography
            variant="caption"
            sx={{
              mt: 5,
              display: 'block',
              textAlign: 'center',
              color: 'rgba(255,255,255,0.15)',
              fontWeight: 600,
              letterSpacing: 3,
            }}
          >
            GateWay Integrity Verified • v2.6.4
          </Typography>
        </MotionBox>
      </Box>
    </Box>
  );
};

export default LoginPage;
